/*
 * Application notification list for short-lived status and error messages.
 * Mounted once by the shell; the toast service retains entries and expiration timers.
 * Keeps notifications visible across route changes without coupling them to the originating view.
 * Example: registerComponents(registry);
 *          <Toasts context={context}/>
 */

import { UIElement, defineUIElements } from '../../runtime/components/ui-element.js';

const colors = {
  error: 'alert-error',
  success: 'alert-success',
  warning: 'alert-warning',
  info: 'alert-info'
};

export class Toasts extends UIElement {
  static properties = { entries: { state: true } };

  constructor() {
    super();
    this.entries = new Map();
  }

  updated(changed) {
    super.updated(changed);
    if (!this.connection || !this.context || this.subscribedTo === this.connection) return;
    this.subscribedTo = this.connection;
    const source = this.context.services.toasts;
    this.entries = source.get();
    this.connection.own(
      source.subscribe(this.connection.guard((entries) => (this.entries = entries)))
    );
  }

  render() {
    const entries = [...this.entries.values()].map(({ key, title, message, type }) => (
      <div key={key} class={colors[type]}>
        {title ? <p class="toast-title">{title}</p> : null}
        <p>{message}</p>
      </div>
    ));
    return (
      <div id="toast-area" class="app-shell-toast">{entries}</div>
    );
  }
}

export function registerComponents(registry) {
  defineUIElements(registry, { 'tbc-toasts': Toasts });
}
